import * as React from 'react';

const ChevronLeft24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
		<path
			d='M14.2275 4.21167C14.5245 3.9233 14.9995 3.93047 15.2881 4.2273C15.5761 4.5243 15.5692 4.99931 15.2725 5.28784L9.65527 10.7498L15.2725 16.2117C15.569 16.5003 15.5764 16.9753 15.2881 17.2722C14.9995 17.5689 14.5245 17.5759 14.2275 17.2878L8.34766 11.5701C8.2391 11.4646 8.15186 11.3377 8.0918 11.197C8.03168 11.056 8.00005 10.9037 8 10.7498C8 10.5958 8.0317 10.4435 8.0918 10.3025C8.15185 10.1617 8.23902 10.0351 8.34766 9.92944L14.2275 4.21167Z'
			fill='currentColor'
		/>
	</svg>
);

export default ChevronLeft24;
